import { FeatureEnabledV2, formatDate, formatDuration, MagicConfigMixin, ModalMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __spreadArray, __decorate, __metadata } from 'tslib';
import { Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { BALANCE_UPDATED, COREX_LIMITS_UPDATED, Feature, USER_JURISDICTION_QUERY } from '@gig/magic-messages';
import { CoreXGamingLimitType, CoreXLimitStatus } from '@gig/magic-sdk/dist/adapter/responsiblegaming/getUserTransactionLimits';
import { getUserTransactionLimits, getMaxWagerLimits, getUserSessionLimits, translatePeriod, translateDuration, translateType, translateStatus, formatLimitAmount } from '../../../utils/limits.js';
import { isUKGC } from '@gig/magic-jurisdictions';

var ViewLimitsComponent = /** @class */ (function (_super) {
    __extends(ViewLimitsComponent, _super);
    function ViewLimitsComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isCancelDepositLimitsEnabled = false;
        _this.limits = [];
        _this.isLoading = false;
        _this.limitType = CoreXGamingLimitType;
        _this.CoreXLimitStatus = CoreXLimitStatus;
        _this.balanceSubscription = null;
        _this.limitsSubscription = null;
        return _this;
    }
    ViewLimitsComponent.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.isLoading = true;
                this.balanceSubscription = window.eventBus.subscribe(BALANCE_UPDATED, function () {
                    _this.getLimits();
                });
                this.getLimits();
                this.limitsSubscription = window.eventBus.subscribe(COREX_LIMITS_UPDATED, function (event) {
                    if (event.payload) {
                        _this.limits = event.payload;
                        _this.isLoading = false;
                    }
                }, { replay: true });
                return [2 /*return*/];
            });
        });
    };
    ViewLimitsComponent.prototype.destroyed = function () {
        var _a;
        if (this.balanceSubscription) {
            this.balanceSubscription.unsubscribe();
        }
        (_a = this.limitsSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    };
    Object.defineProperty(ViewLimitsComponent.prototype, "currency", {
        get: function () {
            return magic.session.getUser().currency;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ViewLimitsComponent.prototype, "shouldShowCancelColumn", {
        get: function () {
            return (this.isCancelDepositLimitsEnabled &&
                this.limits.some(function (limit) { return limit.type === CoreXGamingLimitType.DEPOSIT; }));
        },
        enumerable: false,
        configurable: true
    });
    ViewLimitsComponent.prototype.getLimits = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, userlimits, maxWagerLimits, sessionLimits;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        return [4 /*yield*/, Promise.all([
                                getUserTransactionLimits(),
                                getMaxWagerLimits(),
                                getUserSessionLimits(),
                            ])];
                    case 1:
                        _a = _b.sent(), userlimits = _a[0], maxWagerLimits = _a[1], sessionLimits = _a[2];
                        this.limits = __spreadArray(__spreadArray(__spreadArray([], userlimits), maxWagerLimits), sessionLimits);
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ViewLimitsComponent.prototype.cancelGamingLimitPrompt = function (limitId) {
        var _this = this;
        var cancelLimitModalHeader = 'cancel-gaming-limits-modal.title';
        var cancelLimitModalBody = document.createElement('magic-cancel-gaming-limits-modal');
        cancelLimitModalBody.setAttribute('limit-id', "" + limitId);
        var cancelLimitModalOptions = {
            dismissible: true,
            dismissibleBackdrop: true,
            onClose: function (_, submitted) { return __awaiter(_this, void 0, void 0, function () {
                var currentJurisdiction, lastFinancialLimitReviewOnUtc;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!submitted) return [3 /*break*/, 3];
                            this.getLimits();
                            return [4 /*yield*/, window.queryBus.query(USER_JURISDICTION_QUERY)];
                        case 1:
                            currentJurisdiction = _a.sent();
                            if (!isUKGC(currentJurisdiction)) return [3 /*break*/, 3];
                            lastFinancialLimitReviewOnUtc = new Date();
                            return [4 /*yield*/, magic.methods.users.updateUserProfile({
                                    lastFinancialLimitReviewOnUtc: lastFinancialLimitReviewOnUtc.toISOString(),
                                })];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            }); },
        };
        this.openModal(cancelLimitModalBody, cancelLimitModalHeader, cancelLimitModalOptions);
    };
    __decorate([
        FeatureEnabledV2({
            slug: Feature.CANCEL_DEPOSIT_LIMITS,
        }),
        __metadata("design:type", Object)
    ], ViewLimitsComponent.prototype, "isCancelDepositLimitsEnabled", void 0);
    ViewLimitsComponent = __decorate([
        Component({
            name: 'corex-view-limits',
            filters: {
                formatDate: function (value, noDate) {
                    return value ? formatDate(value) : noDate;
                },
                formatDuration: formatDuration,
                translatePeriod: translatePeriod,
                translateDuration: translateDuration,
                translateType: translateType,
                translateStatus: translateStatus,
                formatLimitAmount: formatLimitAmount,
            },
        })
    ], ViewLimitsComponent);
    return ViewLimitsComponent;
}(Mixins(MagicConfigMixin, ModalMixin)));

export default ViewLimitsComponent;
